import React, { useState, useEffect, useCallback } from "react";
import Select from "react-select";
import {  useNavigate } from "react-router-dom";
import "../Dashboard/Index.css";
// import Sidebar from "../../Sidebar/Sidebar";
import "../../Assets/Pages.css";
import { CiSearch } from "react-icons/ci";
// import formatDate from "../../Component/DateConvert";
import {ViewRequestdetailsApi,RequestMessageSendApi, ViewRepleyMessageApi} from "../../Config/api";
import ReactPaginate from "react-paginate";
import "../../Assets/Pagination.css";
import nodatafound from "../../Images/Noimagefound/Noimgfound";
import pageloader from "../../Loader/pageloading/Pageloader";
// import { setEmployees as setEmployeesRedux } from "../../Slice/employeeSlice";
//import { Store } from "../../Store";
import perPageOptions from "../../JsonData/Perpagelist";
import { getUserDetails } from "../../Services/Storage";
import { getRegisterId } from "../../Config/userId";
import { employeeAccess,employeeAddAccess,} from "../../Services/AccessCondition";
import Header from "../Header/Header";
import Sidebar from "../Sidebar/Sidebar";
import "../Request/requestunique.css";
import { toast } from "react-toastify";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faDownload } from "@fortawesome/free-solid-svg-icons";

const Requestuniqueid = () => {
  const userDetails = getUserDetails();
  const accessid = userDetails?.get_access_role?.[0]?.invite_user_details?.[0]?.register || "";
  const register_id = getRegisterId();
  //const AccessRole = employeeAccess();
  const addAcess = employeeAddAccess();
  const [currentpage, setCurrentPage] = useState(1);
  const [search, setSearchword] = useState("");
  const [isloading, setIsLoading] = useState(true);
  const [totalEmployeeCount, setTotalEmployeeCount] = useState(0);
  const [employees, setEmployees] = useState([]);
  const [isAllChecked, setIsAllChecked] = useState(false);
  const [selectedEmployees, setSelectedEmployees] = useState([]);
  const [perpage, setperpage] = useState(10);
  const [perpagefilter, setperpagefilter] = useState({value: 10,label: "10",});
  const [showReplyPopup, setShowReplyPopup] = useState(false);
  const [selectedRow, setSelectedRow] = useState(null);
  const [replyMessage, setReplyMessage] = useState("");
  const [showViewPopup, setShowViewPopup] = useState(false);
  const [viewReplyMessages, setViewReplyMessage] = useState([]);
  const [selectedFiles, setSelectedFiles] = useState([]);
  const [viewFiles, setViewFiles] = useState([]);
  
  const navigate = useNavigate();
  const handlePerPageChange = (selectedOption) => {
    setperpage(selectedOption.value);
    setperpagefilter(selectedOption);
    setCurrentPage(1);
  };

  useEffect(() => {
    if (selectedEmployees.length === employees.length) {
      setIsAllChecked(true);
    } else {
      setIsAllChecked(false);
    }
  }, [selectedEmployees, employees.length]);

 

  // const handleAllCheckboxChange = () => {
  //   if (isAllChecked) {
  //     setSelectedEmployees([]);
  //   } else {
  //     setSelectedEmployees(employees.map((employee) => employee.register_id));
  //   }
  //   setIsAllChecked(!isAllChecked);
  // };
  // const handleCheckboxChange = (id) => {
  //   setSelectedEmployees((prevState) =>
  //     prevState.includes(id)
  //       ? prevState.filter((empId) => empId !== id)
  //       : [...prevState, id]
  //   );
  // };

  const handleSearch = (event) => {
    setSearchword(event.target.value);
  };

  const handleaddbutton = () => {
    navigate("/Addrequestdetails");
  };


  const currentPageNo = (selectedPage) => {
    setCurrentPage(selectedPage.selected + 1);
  };

  const fetchEmployeeList = useCallback(async () => {
    try {
      setIsLoading(true);
      const response = await ViewRequestdetailsApi(
        `?register_id=${register_id}&page=${currentpage}&page_count=${perpage}&search=${search}`
      );
      setEmployees(response.data.staff_request_details);
      setTotalEmployeeCount(response.data.page_context.total);
    } catch (error) {
    } finally {
      setIsLoading(false);
    }
  }, [
    currentpage,
    register_id,
    perpage,
    search,
   
  ]);

  useEffect(() => {
    fetchEmployeeList();
  }, [fetchEmployeeList]);

  const handleFileChange = (e) => {
  const files = Array.from(e.target.files);
  setSelectedFiles(files);
};

  const handleSendReply = async () => {
  if (!selectedRow) return;
  if (!replyMessage.trim() && selectedFiles.length === 0) {
   toast.error("Please enter a reply message or select files", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });
    return;
  }

  const formData = new FormData();

  formData.append("register", register_id);          // 413 (login user)
  formData.append("receiver", selectedRow.sender);  // 380
  formData.append("sender", register_id);            // 404 (current user)
  formData.append("old_company", selectedRow.old_company);
  formData.append("request", selectedRow.id);        // request id
  formData.append("staff_unique_id", selectedRow.staff_unique_id);

   if (replyMessage.trim()) {
    formData.append("response", replyMessage);
  }

   // Append all files as array to backend
   selectedFiles.forEach((file) => {
    formData.append("file", file);
  });


  try {
    await RequestMessageSendApi(formData);

    toast.success("Reply sent successfully!", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });

    setShowReplyPopup(false);
    setReplyMessage("");
     setSelectedFiles([]);
     // Reset file input
     const fileInput = document.querySelector('input[type="file"]');
     if (fileInput) fileInput.value = '';

  } catch (error) {
    console.error(error);
    toast.error("Failed to send reply. Please try again.", {
      position: "top-center",
      autoClose: 2000,
      closeButton: false,
      className: "custom_toast",
    });

    console.error("Error sending reply:", error);
     if (showViewPopup && selectedRow) {
      handleViewRequest(selectedRow);
    }
  }
};

const handleViewRequest = async (row) => {
  setSelectedRow(row);
  setShowViewPopup(true);
  setViewReplyMessage([]);
   setViewFiles([]);

  try {
    const res = await ViewRepleyMessageApi(
      `?request_id=${row.id}&register_id=${register_id}`
      
    );
     setViewFiles(res.data.files || []);

    //console.log("Reply API:", res.data);

    const responses =
      res?.data?.reply_request?.response_details || [];
      

    //if (responses.length > 0) {
      // adjust key name if backend uses different field
      //setViewReplyMessage(responses[0].response || "");
    //} else {
      setViewReplyMessage(responses);   // no reply found
      
    //}

  } catch (err) {
    console.error(err);
  }
};

// Function to open file in new window
const handleViewFile = (fileUrl, fileName) => {
  const fileExtension = fileName?.split('.')?.pop()?.toLowerCase();
  
  // For images and PDFs, open in new window
  if (['jpg', 'jpeg', 'png', 'gif', 'pdf', 'html'].includes(fileExtension)) {
    window.open(fileUrl, '_blank');
  } else {
    // For other files, trigger download
    handleDownloadFile(fileUrl, fileName);
  }
};

// Function to download file (fetches blob to ensure cross-origin downloads)
const handleDownloadFile = async (fileUrl, fileName) => {
  try {
    // attempt to download via fetch to avoid potential cross-origin issues
    const response = await fetch(fileUrl, {
      mode: 'cors'
    });
    if (!response.ok) throw new Error('Network response was not ok');
    const blob = await response.blob();
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = fileName || 'download';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    window.URL.revokeObjectURL(url);
  } catch (err) {
    // fallback: open in new window which may prompt user to save
    console.error('download failed, falling back to direct link', err);
    const link = document.createElement('a');
    link.href = fileUrl;
    link.download = fileName || 'download';
    link.target = '_blank';
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
  }
};

// Function to get file icon based on file type
const getFileIcon = (fileName) => {
  const extension = fileName?.split('.')?.pop()?.toLowerCase();
  switch (extension) {
    case 'pdf':
      return '📄';
    case 'jpg':
    case 'jpeg':
    case 'png':
    case 'gif':
      return '🖼️';
    case 'html':
      return '🌐';
    case 'doc':
    case 'docx':
      return '📝';
    case 'xls':
    case 'xlsx':
      return '📊';
    case 'zip':
    case 'rar':
      return '📦';
    default:
      return '📎';
  }
};

// Function to extract file name from URL
const getFileNameFromUrl = (url) => {
  return url.split('/').pop() || 'file';
};


// Helper function to format file size
// const formatFileSize = (bytes) => {
// if (bytes === 0) return '0 Bytes';
// const k = 1024;
// const sizes = ['Bytes', 'KB', 'MB', 'GB'];
// const i = Math.floor(Math.log(bytes) / Math.log(k));
// return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + ' ' + sizes[i];
// };

employees.map((employee) => (
  <tr key={employee.id}>
    ...
  </tr>
))


  return (
    <>
      <div className="index-container">
        <Header />
        <div className="index-content-parent">
          <div className="index-content">
            <Sidebar />
            <div className="index-content-sub">
              <div className="index-main">
                <div className="pages-subheader">
                  {selectedEmployees.length === 0 ? (
                    <>
                      <div className="pages-subheader-sub-1">
                        <p>Request</p>
                        <span className="header-search-add-parent">
                          <div className="pages-serach-view">
                            <CiSearch className="page-search-icon" />
                            <input
                              onChange={handleSearch}
                              className="pages-serach"
                              placeholder="Search Employee"
                              type="search"
                            />
                          </div>
                          {/* <button
                            className="pages-addempbutton"
                            onClick={handleprintalldata}
                          >
                            Print All
                          </button> */}
                          {addAcess ? (
                            <>
                              {/* <button
                                className="pages-addempbutton"
                                onClick={handleincompbutton}
                              >
                                Incomplete
                              </button> */}
                              <button
                                className="pages-addempbutton"
                                onClick={handleaddbutton}
                              >
                                Add Request
                              </button>
                            </>
                          ) : (
                            <></>
                          )}
                        </span>
                      </div>
                    </>
                  ) : (
                    <>
                     
                    </>
                  )}
                  <div className="pages-line"></div>
                </div>
                
                <div className="pages-maincontent">
                  {isloading ? (
                    <div className="loader-container">
                      <img src={pageloader.page_loader} alt="Loading..." />
                    </div>
                  ) : (
                    <div className="pages-table-container">
                      <table className="pages-table">
                        {employees.length > 0 && (
                          <thead>
                            <tr>
                              {/* {AccessRole ? (
                                <th>
                                  <input
                                    type="checkbox"
                                    checked={isAllChecked}
                                    onChange={handleAllCheckboxChange}
                                  />
                                </th>
                              ) : (
                                <th></th>
                              )} */}

                              <th>Name</th>                            
                              <th>Uniqu ID</th> 
                              <th>Company</th>
                              <th>Request Date</th>
                              {/* <th>Request Status</th> */}
                              <th>Query</th>
                              <th>View</th>
                              <th>Reply </th>
                            </tr>
                          </thead>
                        )}

                        <tbody>
                          {employees.length > 0 ? (
                            employees.map((employee) => (
                              <tr key={employee.id}>
                                {/* {AccessRole ? (
                                  <td>
                                    <input
                                      type="checkbox"
                                      checked={selectedEmployees.includes(
                                        employee.id
                                      )}
                                      onChange={() =>
                                        handleCheckboxC hange(
                                          employee.id
                                        )
                                      }
                                    />
                                  </td>
                                ) : (
                                  <td></td>
                                )} */}
                             
                                <td>{employee.staff_name}</td>        
                                <td>{employee.staff_unique_id}</td>
                                <td>{employee.company_name}</td>
                                <td>
                                      {new Date(employee.request_dt).toLocaleDateString('en-GB', {
                                        day: 'numeric',
                                        month: 'short',
                                        year: 'numeric'
                                      })}
                                    </td>
                                  {/* <td> {employee.req_status ? "Active" : "Inactive"}</td> */}
                                  <td title={employee.query || ""}>
                                          {employee.query && employee.query.length > 20
                                            ? employee.query.substring(0, 20) + "..."
                                            : employee.query}
                                        </td>
                                   <td>
                                    <span
                                      className="link-span"
                                      onClick={() => handleViewRequest(employee)}
                                    >
                                      View
                                    </span>
                                  </td>
                                  <td>
                                    {(() => {

                                      const senderId =
                                        employee.sender ??
                                        employee.sender_id ??
                                        employee.senderId;   // fallback (safety)

                                      if (!senderId) {
                                        return <span>-</span>;   // no sender info from API
                                      }

                                      return employee.reply_btn  ? (
                                    
                                                <span
                                        className="link-span"
                                        onClick={() => {
                                          setSelectedRow(employee);
                                          setShowReplyPopup(true);
                                        }}
                                      >
                                        Reply
                                      </span>
                                      ) : (
                               
                                          <span
                                          className="link-span"
                                          // onClick={() =>
                                          //   navigate("/Viewedituniqueid", {
                                          //     state: { requestId: employee.id }
                                          //   })
                                          // }
                                        >
                                         
                                        </span>
                                      );
                                    })()}
                                  </td>
                                                                                                      
                              </tr>   
                            ))
                          ) : (
                            <tr>
                              <td colSpan={9} className="no-data-table">
                                <img
                                  src={nodatafound.no_data_img}
                                  alt="No Data Found"
                                  className="no-data-found"
                                />
                              </td>
                            </tr>
                          )}
                        </tbody>
                      </table>
                      {showReplyPopup && selectedRow && (
                            <div className="reply-popup-overlay">
                              <div className="reply-popup-box">

                                <div className="reply-popup-header">
                                  <h4>Reply</h4>
                                  <span
                                    className="popup-close"
                                    onClick={() => setShowReplyPopup(false)}
                                  >
                                    ×
                                  </span>
                                </div>

                                <div className="reply-popup-body">
                              <div className="form-row-div">
                                  <div className="form-row">
                                    <label>Unique ID</label>
                                    <input
                                      type="text"
                                      value={selectedRow.staff_unique_id}
                                      readOnly
                                    />
                                  </div>
                                   <div className="form-row">
                                    <label>Staff Name</label>
                                    <input
                                      type="text"
                                      value={selectedRow.staff_name}
                                      readOnly
                                    />
                                  </div>
                                   <div className="form-row-1">
                                    <label>Company Name</label>
                                    <input
                                      type="text"
                                      value={selectedRow.company_name}
                                      readOnly
                                    />
                                  </div>
                                   <div className="form-row-1">
                                    <label>Request Date</label>
                                  <input
                                    type="text"
                                    value={(() => {
                                      const date = new Date(selectedRow.request_dt);
                                      const day = date.getDate();
                                      const month = date.toLocaleDateString('en-US', { month: 'short' });
                                      const year = date.getFullYear();
                                      return `${day} ${month} ${year}`;
                                    })()}
                                    readOnly
                                    />
                                  </div>
                                </div>
                                 <div className="form-row">
                                    <label>Sender Message </label>
                                    <textarea
                                      type="text"
                                      value={selectedRow.query}
                                      readOnly
                                    style={{ width: "100%",height:"100px" }}
                                    />
                                  </div>
                                  <div className="form-row">
                                    <label>Reply Message</label>
                                    <textarea
                                      placeholder="Enter reply message..."
                                       value={replyMessage}
                                      onChange={(e) => setReplyMessage(e.target.value)}
                                    />
                                  </div>
                                  <div className="form-row">

                                    <label>File Upload</label>
                                    <input type="file"   multiple   onChange={handleFileChange} style={{padding:"5px"}}/>
                                   {selectedFiles.length > 0 && (
                                      <div className="selected-files">
                                        <small>Selected files: {selectedFiles.length}</small>
                                        <ul>
                                          {selectedFiles.map((file, index) => (
                                            <li key={index}>{file.name}</li>
                                          ))}
                                        </ul>
                                      </div>
                                    )}
                                    </div>
                                </div>
                                <div className="reply-popup-footer">
                                  <button onClick={handleSendReply}>Send Reply</button>
                                </div>

                              </div>
                            </div>
                          )}
                          {showViewPopup && selectedRow && (
                          <div className="reply-popup-overlay">
                            <div className="reply-popup-box">

                              <div className="reply-popup-header">
                                <h4>View Request</h4>
                                <span
                                  className="popup-close"
                                  onClick={() => setShowViewPopup(false)}
                                >
                                  ×
                                </span>
                              </div>

                              <div className="reply-popup-body">
                            <div className="reply-popup-body-1">
                                <div className="form-row-popup">
                                  <label>Unique ID</label>
                                  <input
                                    type="text"
                                    value={selectedRow.staff_unique_id}
                                    readOnly
                                  />
                                </div>

                                <div className="form-row">
                                  <label>Staff Name</label>
                                  <input
                                    type="text"
                                    value={selectedRow.staff_name}
                                    readOnly
                                  />
                                </div>

                                <div className="form-row">
                                  <label>Company Name</label>
                                  <input
                                    type="text"
                                    value={selectedRow.company_name}
                                    readOnly
                                  />
                                </div>

                                <div className="form-row">
                                  <label>Request Date</label>
                                <input
                                type="text"
                                value={(() => {
                                  const date = new Date(selectedRow.request_dt);
                                  const day = date.getDate();
                                  const month = date.toLocaleDateString('en-US', { month: 'short' });
                                  const year = date.getFullYear();
                                  return `${day} ${month} ${year}`;
                                })()}
                                readOnly
                              />
                                </div>
                              </div>
                               <div className="form-row-5">
                                  <label>Sender Message </label>
                                  (<label style={{color:"#2a7ac7",fontSize:"12px"}}>You</label>)
                                  <div className="chat-boxs">
                                  {selectedRow.query}
                                  
                                  </div>
                                  
                                </div>
                              <br></br>
                              <div className="form-rowsss">
                               
                                  <label>Reply Messages</label> {" "}
                                    (
                                      <label style={{color:"#2a7ac7",fontSize:"12px",textAlign:"justify"}}>{selectedRow.company_name}</label>
                                    )
                                  <div className="chat-box">

                                    {viewReplyMessages.length === 0 ? (
                                      <div className="chat-left">No replies yet</div>
                                    ) : (
                                      viewReplyMessages.map((item, index) => (
                                        <div
                                          key={index}
                                          className={
                                             String(item.sender_id) === String(register_id)
                                              ? "chat-right"
                                              : "chat-left"
                                          }
                                        >
                                         <div className="chat-message-text">
                                            {item.response || ""}
                                          </div>
                                          
                                          {item.files && item.files.length > 0 && (
                                            <div className="chat-message-files">
                                              {item.files.map((fileUrl, fileIndex) => {
                                                const fileName = getFileNameFromUrl(fileUrl);
                                                const fileIcon = getFileIcon(fileName);
                                                return (
                                                  <div key={fileIndex} className="file-item">
                                                    <span className="file-icon">{fileIcon}</span>
                                                    <span 
                                                      className="file-name"
                                                      onClick={() => handleViewFile(fileUrl, fileName)}
                                                      style={{ cursor: 'pointer', color: '#2b7dd4', textDecoration: 'underline' }}
                                                      title="Click to view or download"
                                                    >
                                                      {fileName}
                                                    </span>
                                                    <span
                                                      className="file-download"
                                                      onClick={() => handleDownloadFile(fileUrl, fileName)}
                                                      style={{ cursor: 'pointer', marginLeft: '6px',color:"green" }}
                                                      title="Download"
                                                    >
                                                      <FontAwesomeIcon icon={faDownload}/>
                                                    </span>
                                                  </div>
                                                );
                                              })}
                                            </div>
                                          )}
                                         <div className="chat-message-date">
                                            {item?.created_at
                                              ? new Date(item.created_at).toLocaleDateString("en-GB")
                                              : item?.response_dt
                                              ? new Date(item.response_dt).toLocaleDateString("en-GB")
                                              : new Date().toLocaleDateString("en-GB")}
                                          </div>
                                        </div>
                                      ))
                                    )}

                                  </div>
                                </div>
                            </div>
                            </div>
                          </div>
                        )}
                    </div>
                    
                  )}
                  <div style={{ float: "right" }} id="pagination_link"></div>
                  <div className="pagenation-perpage-cont">
                    <div>
                      {!isloading && totalEmployeeCount > perpage ? (
                        <>
                          <div>
                            <ReactPaginate
                              pageCount={Math.ceil(
                                totalEmployeeCount / perpage
                              )}
                              pageRangeDisplayed={3}
                              marginPagesDisplayed={2}
                              onPageChange={currentPageNo}
                              forcePage={currentpage - 1}
                              containerClassName={"pagination"}
                              pageClassName={"page-item"}
                              pageLinkClassName={"page-link"}
                              previousClassName={"page-item"}
                              previousLinkClassName={"page-link"}
                              nextClassName={"page-item"}
                              nextLinkClassName={"page-link"}
                              breakClassName={"page-item"}
                              breakLinkClassName={"page-link"}
                              activeClassName={"active"}
                            />
                          </div>
                        </>
                      ) : (
                        <></>
                      )}
                    </div>
                    {!isloading && totalEmployeeCount >= 11 ? (
                      <div className="select-per-page-container">
                        <Select
                          menuPlacement="top"
                          className="per-page-container"
                          options={perPageOptions}
                          value={perpagefilter}
                          onChange={handlePerPageChange}
                          placeholder="page"
                        />
                      </div>
                    ) : (
                      <></>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
    </>
  );
};

export default Requestuniqueid;
